mainHandler = {
    
    funders : {
        panel : $('.panel-funders'),
    },

    campaign : {
        panel : $('.panel-campaign'),
        initFlickity : function() {
            var self = this;

            self.panel.find('.flickity-container').flickity({
                cellSelector: '.flickity-cell',
                cellAlign: 'left',
                fade: true,
                contain: true,
                pageDots: true,
                dragTreshold: 2,
                prevNextButtons: false
            });
        },
    },

    main : {
        resizeImage : function () {
            $('body').find('.resize-image').each(function() {
                if (Foundation.MediaQuery.only('small')) {
                    var imgWidth = $(this).outerWidth();
                    var newHeight = (imgWidth / 4) * 3;

                    $(this).css({
                        'height': newHeight+'px'
                    });
                }
            });
        },
        outbondLinkCheck : function () {
            $('a').each(function() {
                $iconLink = $(this);
                var href = this.hostname;

                if (href && href != window.location.host) {
                    $(this).attr('target', '_new');
                }
            });
        },
    },
    
    resizeTimer: null,

    adjustMainSpacing: function() {
        $('main').css('margin-top',$('header').outerHeight());
    },

    init : function() {
        var self = this;
        
        //self.runText.runEngine();

        self.campaign.initFlickity();
        self.main.resizeImage();
        self.main.outbondLinkCheck();

        $(window).on('load resize', function() {
            self.main.resizeImage();
        });

        if ($('.panel-hero').length == 0) {
            $(window).on('resize', function() {
                clearTimeout(self.resizeTimer);
                self.resizeTimer = setTimeout(function() {
                    self.adjustMainSpacing();
                }, 25);
            });
            this.adjustMainSpacing();
            $('header').addClass('bg-color-navy');
            $('main').addClass('pb-3');
        }

        self.funders.panel.each(function(){
            var parent = $(this);

            parent.find('[href="#expand-funders"]').on('click', function(e) {
                e.preventDefault();
    
                parent.find('.item-cell').removeClass('hide-item');
                $(this).addClass('hide');
            });
        });
    }
}